export const counter_card = [
    {
        title : "Clientes",
        number : 4700
    },
    {
        title : "Mil Pedidos",
        number : 149
    },
    {
        title : "M em Comissões",
        number : 2.1
    },

    {
        title : "M em Vendas",
        number : 42.4
    }
]